import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-55" data-mp="1gal1dn7qnrd8">
      <div className="mx-auto max-w-3xl" data-id="element-56" data-mp="2dzemhm8wv9jy">
        <SectionTitle data-id="element-57" data-mp="2dyd93b4faaz2">Frequently asked questions</SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-58" data-mp="292edp3kofsp5">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border-2 bg-white transition-colors duration-150 ease-out ${open === index ? 'border-brand shadow-md' : 'border-brand/10'}`} data-id="element-59" data-mp="2418o3embclju" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-4 text-left text-xs font-extrabold uppercase text-brand-deep md:text-sm" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-60" data-mp="sl0it5fhyw4h">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-61" data-mp="fk9u3ulvr1uu" />
              </button>
              <AnimatePresence initial={false} data-id="element-62" data-mp="6r6ilrusoz2u">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-brand/10 px-4 py-3 text-sm leading-relaxed text-slate-600" data-id="element-63" data-mp="biongqzxvjt3">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}